import React from 'react'
import cx from 'classnames'
import RegionSelect from './region-select'
import Icon from 'lib/components/icon'

class MobileToolbar extends React.PureComponent {
  state = {
    isMenuOpen: false
  }

  toggle = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen })
  }

  close() {
    this.setState({ isMenuOpen: false })
  }

  componentWillReceiveProps(props) {
    if (props.viewing !== this.props.viewing) {
      this.close()
    }
  }

  render() {
    const { children, region, viewing } = this.props
    const { isMenuOpen } = this.state

    const menuClassName = cx('mobile-toolbar__menu', {
      '-active': isMenuOpen
    })

    const arrowType = isMenuOpen ? 'arrow-up' : 'arrow-down'

    return (
      <div className="mobile-toolbar">
        <RegionSelect region={region} />

        <div className="mobile-toolbar__viewing">
          <span className="mobile-toolbar__viewing__label type-subtitle">
            Viewing:
          </span>
          <button
            className="mobile-toolbar__viewing__button"
            onClick={this.toggle}
          >
            <span className="type-headline">{viewing}</span>
            <Icon
              type={arrowType}
              className="mobile-toolbar__viewing__arrow"
              width="12px"
              height="12px"
            />
          </button>
        </div>

        <div className={menuClassName}>{children}</div>
      </div>
    )
  }
}

export default MobileToolbar



// WEBPACK FOOTER //
// ./src/components/toolbar-mobile.js